import { AppUser } from '../users/types';

/*
 * Action Types
 */
export enum OrdersSchoolTypes {
  CREATE_ORDER_SCHOOL_REQUEST = '@ordersSchool/CREATE_ORDER_SCHOOL_REQUEST',
  CREATE_ORDER_SCHOOL_SUCCESS = '@ordersSchool/CREATE_ORDER_SCHOOL_SUCCESS',
  CREATE_ORDER_SCHOOL_FAILURE = '@ordersSchool/CREATE_ORDER_SCHOOL_FAILURE',

  LIST_ORDERS_SCHOOL_REQUEST = '@ordersSchool/LIST_ORDERS_SCHOOL_REQUEST',
  LIST_ORDERS_SCHOOL_SUCCESS = '@ordersSchool/LIST_ORDERS_SCHOOL_SUCCESS',
  LIST_ORDERS_SCHOOL_FAILURE = '@ordersSchool/LIST_ORDERS_SCHOOL_FAILURE',

  GET_ORDER_SCHOOL_REQUEST = '@ordersSchool/GET_ORDER_SCHOOL_REQUEST',
  GET_ORDER_SCHOOL_SUCCESS = '@ordersSchool/GET_ORDER_SCHOOL_SUCCESS',
  GET_ORDER_SCHOOL_FAILURE = '@ordersSchool/GET_ORDER_SCHOOL_FAILURE',

  FILTER_ORDER_SCHOOL_REQUEST = '@ordersSchool/FILTER_ORDER_SCHOOL_REQUEST',
  FILTER_ORDER_SCHOOL_SUCCESS = '@ordersSchool/FILTER_ORDER_SCHOOL_SUCCESS',
  FILTER_ORDER_SCHOOL_FAILURE = '@ordersSchool/FILTER_ORDER_SCHOOL_FAILURE',

  CHARGE_REQUEST_REPEAT_ORDER_SCHOOL_REQUEST = '@ordersSchool/CHARGE_REQUEST_REPEAT_ORDER_SCHOOL_REQUEST',
  CHARGE_REQUEST_REPEAT_ORDER_SCHOOL_SUCCESS = '@ordersSchool/CHARGE_REQUEST_REPEAT_ORDER_SCHOOL_SUCCESS',
  CHARGE_REQUEST_REPEAT_ORDER_SCHOOL_FAILURE = '@ordersSchool/CHARGE_REQUEST_REPEAT_ORDER_SCHOOL_FAILURE',

  DELETE_CHARGE_REQUEST_SCHOOL_REQUEST = '@orders/DELETE_CHARGE_REQUEST_SCHOOL_REQUEST',
  DELETE_CHARGE_REQUEST_SCHOOL_SUCCESS = '@orders/DELETE_CHARGE_REQUEST_SCHOOL_SUCCESS',
  DELETE_CHARGE_REQUEST_SCHOOL_FAILURE = '@orders/DELETE_CHARGE_REQUEST_SCHOOL_FAILURE',
}

/*
 * Data types
 */
export interface PayamentInterface {
  type: string;
  data: object;
}

export interface OrderUsers {
  value: number;
  userDocument?: string;
  userId?: string;
}

export interface OrderInterface {
  transportOperatorId?: string;
  payment: PayamentInterface;
  orders: OrderUsers[];
}

export interface ChargeRequestOrderInterface {
  id: string;
  userId: string;
  status: number;
  value: number;
  User?: AppUser;
  createdAt: string;
  updatedAt: string;
  chargeRequestId: string;
  transportOperatorId?: string;
}

export interface DataObjectInterface {
  data: {
    status: string;
    calendario: {
      expiracao: string;
      criacao: string;
    };
    location: string;
    txid: string;
    revisao: string;
    valor: {
      original: string;
    };
    chave: string;
    solicitacaoPagador: string;
    infoAdicionais: any[];
  };
}

export interface PaymentRequestHistory {
  id: string;
  fromStatus: number;
  toStatus: number;
  message: string;
  createdAt: string;
  updatedAt: string;
  paymentRequestId: string;
}

export interface PaymentRequestInterface {
  id: string;
  type: string;
  status: number;
  value: number;
  tax: number;
  data: any;
  createdAt: string;
  updatedAt: string;
  chargeRequestId: string;
  PaymentRequestHistories: PaymentRequestHistory[];
  authUserId?: string;
}

export interface ChargeRequestHistory {
  id: string;
  fromStatus: number;
  toStatus: number;
  message: string;
  createdAt: string;
  updatedAt: string;
  chargeRequestId: string;
}

export interface ChargeRequestInterface {
  id: string;
  invoiceId?: string;
  userId: string;
  type: string;
  status: number | string;
  value: number;
  nsu: number | null;
  ChargeRequestOrders: ChargeRequestOrderInterface[];
  createdAt: string;
  updatedAt: string;
  PaymentRequest: PaymentRequestInterface;
  ChargeRequestHistories: ChargeRequestHistory[];
  paymentStatus?: string;
  paymentType?: string;
}

/*
 * State type
 */
export interface OrdersSchoolState {
  readonly ordersSchoolList: OrderInterface[];
  readonly orderSchoolData: OrderInterface;
  readonly chargeRequestSchoolList: ChargeRequestInterface[];
  readonly chargeRequestSchoolData: ChargeRequestInterface;
  readonly chargeRequestRepeatSchoolData: ChargeRequestInterface;
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
}
